// extracted by mini-css-extract-plugin
export var cartIcon = "_gw-0";
export var cartIconContainer = "_gw-1";